import React, { Component } from "react"

import Header from '../../components/Header/Header';
import Content_ViajeDeEmer from "./Content_ViajeDeEmer";
import Footer from '../../components/Footer/Footer';

class ViajeDeEmergencia extends Component {
    render() {
        return (

            <div class="main-container">
                <Header />
                <Content_ViajeDeEmer />
                <Footer />
            </div>

        )
    }
}

export default ViajeDeEmergencia;